var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_292_23531)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_292_23531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0007 68.9066C71.1189 68.9066 80.1329 57.9586 80.1329 44.4534C80.1329 30.948 77.1735 20 60.0007 20C42.8278 20 39.8678 30.948 39.8678 44.4534C39.8678 57.9586 48.8818 68.9066 60.0007 68.9066ZM21.9747 106.244C21.9678 106.012 21.9712 105.42 21.9747 106.244V106.244ZM98.0249 106.887C98.0287 105.323 98.0358 106.661 98.0249 106.887V106.887Z",
    fill: "#CCD1E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9823 105.256C97.6095 81.7299 94.5369 75.0261 71.0246 70.7827C71.0246 70.7827 67.7149 75.0001 60.0006 75.0001C52.2863 75.0001 48.976 70.7827 48.976 70.7827C25.7203 74.9799 22.4609 81.5841 22.0323 104.492C21.9972 106.362 21.9809 106.461 21.9746 106.244C21.976 106.65 21.9778 107.403 21.9778 108.715C21.9778 108.715 27.5755 120 60.0006 120C92.4252 120 98.0235 108.715 98.0235 108.715C98.0235 107.872 98.024 107.286 98.0249 106.887C98.0186 107.021 98.006 106.761 97.9823 105.256Z",
    fill: "#CCD1E0"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 116,
    height: 116,
    rx: 58,
    stroke: "white",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_292_23531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_292_23531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(10 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/DefaultAvatar.3782c6a2e805dcbc0d0f4feecbb2c8a4.svg";
export { ForwardRef as ReactComponent };